import {
  Dialog as MUIDialog,
  DialogTitle,
  DialogContent,
  Box,
  Stack,
  useMediaQuery,
} from '@mui/material';

import Button from '../../../components/styledComponents/Button';
import { RemoveButton } from '../../../components/styledComponents/IconButtons';
import colors from '../../../constants/colors';
import theme from '../../../styles/theme';
import { setWithExpiry } from '../../../utils/helpers';

interface RemoveFromWalletConfirmationDialogProps {
  closeDialog: () => void;
  open: boolean;
  text: string;
  removeFromWallet: () => void;
}

const RemoveFromWalletConfirmationDialog = ({
  closeDialog,
  open,
  text,
  removeFromWallet,
}: RemoveFromWalletConfirmationDialogProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('tablet'));

  const cancel = (): void => {
    setWithExpiry('declinedPaperless', true, 90);
    closeDialog();
  };

  return (
    <MUIDialog
      aria-labelledby="walletRemovalLabel"
      data-testid="remove-from-wallet-confirmation-dialog"
      open={open}
      onClose={closeDialog}
      sx={{ backdropFilter: 'blur(5px)' }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 4,
            margin: 0,
            px: { mobile: 3, tablet: 4 },
            py: { mobile: 3, tablet: 3 },
            position: { mobile: 'fixed', tablet: 'relative' },
            width: { mobile: 1, tablet: 480 },
            height: 'auto',
            maxHeight: 1,
          },
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: 1,
        }}
      >
        <RemoveButton
          aria-label="Close remove from wallet dialog"
          data-testid="close-paperless-dialog-button"
          onClick={closeDialog}
          autoFocus
        />
      </Box>
      <DialogTitle
        id="walletRemovalLabel"
        sx={{
          fontSize: 28,
          fontWeight: 700,
          textAlign: 'center',
          p: 0,
          my: { mobile: 2, tablet: 3 },
        }}
      >
        Are you sure you want to remove your {text}?
      </DialogTitle>
      <DialogContent
        sx={{
          px: 0,
          pb: 3,
        }}
      >
        <Stack direction="column" spacing={isMobile ? 1 : 2}>
          <Button
            fullWidth
            data-testid="removeFromWalletCancelButton"
            variant="outlined"
            sx={{
              whiteSpace: 'nowrap',
              color: colors.csaaBlack,
              border: `2px solid ${colors.csaaBlack}`,
              height: { mobile: 36, tablet: 42 },
            }}
            onClick={cancel}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            data-testid="removeFromWalletConfirmationButton"
            variant="contained"
            sx={{
              whiteSpace: 'nowrap',
              height: { mobile: 36, tablet: 42 },
            }}
            onClick={removeFromWallet}
          >
            Yes, remove
          </Button>
        </Stack>
      </DialogContent>
    </MUIDialog>
  );
};

export default RemoveFromWalletConfirmationDialog;
